export default status => {
  if (status === 'BANK_VERIFICATION_PENDING') {
    return '#ffe0b1';
  } if (status === 'PENDING_FOR_SELF_APPROVAL') {
    return '#ffe0b1';
  } if (status === 'VERIFICATION_PENDING') {
    return '#e2e2e2';
  } if (status === 'VERIFIED') {
    return '#ececff';
  } return '#e2e2e2';
};
